import { FC, useEffect, useRef } from 'react';

const usePolling = (callback: () => void, interval: number) => {
    const savedCallback = useRef<(() => void) | null>(null);

    // After every render, save the latest callback into our ref.
    useEffect(() => {
        if (!savedCallback.current) {
            savedCallback.current = callback;
            callback();
        }
    });

    useEffect(() => {
        const fetch = () => {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };

        const id = setInterval(fetch, interval);
        return () => clearInterval(id);
    }, [interval]);
};

export default usePolling;
